import { CardRowContainer } from 'components/layout/profile/profileContent/styles';
import { screenMd } from 'constants/styles/breakpoints';
import { colors } from 'constants/styles/colors';
import styled from 'styled-components';

export const TeamCardContainer = styled(CardRowContainer)`
  padding-top: 25px;
  padding-bottom: 15px;
  ${screenMd} {
    padding-top: 35px;
    padding-bottom: 27px;
  }
`;

export const CardHeaderSection = styled.div`
  width: 100%;
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  > h5 {
    font-weight: 700;
    font-size: 24px;
    margin: 0;
  }
  > p {
    font-size: 12px;
    margin: 0;
    color: ${colors.palette.Business_LightThemeGreyDarker};
  }
`;

// Shared by the single-team and bulk content-access dropdowns so both radios
// render the same custom (design-system) style.
export const ContentAccessRadio = styled.input`
  appearance: none;
  -webkit-appearance: none;
  width: 20px;
  height: 20px;
  margin: 0;
  flex-shrink: 0;
  border-radius: 50%;
  border: 2px solid var(--dusty-gray);
  background: var(--grey-lighter);
  display: inline-grid;
  place-content: center;
  cursor: pointer;

  &::before {
    content: '';
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: var(--lilac);
    transform: scale(0);
  }

  &:checked {
    border-color: var(--lilac);
  }

  &:checked::before {
    transform: scale(1);
  }
`;
